import { DetailPageProps } from './DetailPage.decl';

import { Spacer } from '@aircall/tractor';

export function DetailPage({ children, 'data-test': dataTest, ...spacerProps }: DetailPageProps) {
  return (
    <Spacer fluid direction='vertical' space='m' data-test={dataTest} {...spacerProps}>
      {children}
    </Spacer>
  );
}
